var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8005 2.99622C13.2226 2.99622 13.5992 3.26125 13.7419 3.65849L14.2501 5.07408C14.3308 5.29669 14.4874 5.48372 14.6923 5.6023L16.1999 6.47266C16.4046 6.59079 16.6446 6.63261 16.8772 6.59071L18.3578 6.3236C18.7736 6.248 19.192 6.4418 19.4033 6.8078L20.2036 8.18838C20.4154 8.55339 20.3754 9.01205 20.1035 9.33486L19.1321 10.4833C18.9791 10.6639 18.8951 10.8929 18.895 11.1296V12.8703C18.8951 13.107 18.9791 13.336 19.1321 13.5166L20.1035 14.6651C20.3754 14.9879 20.4154 15.4465 20.2036 15.8116L19.4033 17.1921C19.1922 17.5577 18.7743 17.7515 18.3588 17.6763L16.8782 17.4092C16.6456 17.3673 16.4056 17.4091 16.2009 17.5273L14.6933 18.3976C14.4884 18.5162 14.3318 18.7032 14.2511 18.9259L13.7429 20.3414C13.6001 20.739 13.223 21.0041 12.8005 21.0037H11.1998C10.7777 21.0037 10.4011 20.7387 10.2584 20.3414L9.75023 18.9259C9.66959 18.7035 9.51345 18.5166 9.30905 18.3976L7.80042 17.5273C7.59569 17.4091 7.35576 17.3673 7.12314 17.4092L5.64252 17.6763C5.22675 17.7519 4.80832 17.5581 4.59709 17.1921L3.79675 15.8116C3.58495 15.4465 3.62498 14.9879 3.8968 14.6651L4.8682 13.5166C5.02119 13.336 5.1052 13.107 5.1053 12.8703V11.1296C5.1052 10.8929 5.02119 10.6639 4.8682 10.4833L3.9068 9.33486C3.63498 9.01205 3.59496 8.55339 3.80676 8.18838L4.60709 6.8078C4.81819 6.44219 5.23609 6.24846 5.65153 6.3236L7.13214 6.59071C7.36476 6.63261 7.6047 6.59079 7.80942 6.47266L9.31805 5.6023C9.52245 5.48335 9.67859 5.2964 9.75924 5.07408L10.2674 3.65849C10.409 3.26433 10.7811 3.00005 11.1998 2.99622H12.8005Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0002,
    cy: 12,
    r: 2.75115,
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4fa00675559e4a26f9849f40855d4a4e.svg";
export { ForwardRef as ReactComponent };